export default __webpack_public_path__ + "static/media/discover_abjadiyat.e1530f81.png";